(function () {
  var PREV_SVG = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M9 1L3 7l6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NEXT_SVG = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M5 1l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function makeArrow(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'thered-arrow thered-arrow--' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    btn.innerHTML = dir === 'prev' ? PREV_SVG : NEXT_SVG;
    return btn;
  }

  function setupCarousel(scrollEl) {
    if (!scrollEl || scrollEl.dataset.theredArrows) return;
    scrollEl.dataset.theredArrows = '1';

    // Wrap the scrollable element so arrows can be absolutely positioned beside it
    var wrap = document.createElement('div');
    wrap.className = 'thered-carousel-wrap';
    scrollEl.parentNode.insertBefore(wrap, scrollEl);
    wrap.appendChild(scrollEl);

    var prev = makeArrow('prev');
    var next = makeArrow('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      var card = scrollEl.querySelector(':scope > *');
      if (!card) return scrollEl.clientWidth * 0.8;
      var style = getComputedStyle(scrollEl);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      scrollEl.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scrollEl.scrollBy({ left: step(), behavior: 'smooth' });
    });

    function update() {
      var max = scrollEl.scrollWidth - scrollEl.clientWidth;
      if (max <= 2) {
        prev.style.display = 'none';
        next.style.display = 'none';
        return;
      }
      prev.style.display = '';
      next.style.display = '';
      prev.classList.toggle('thered-arrow--disabled', scrollEl.scrollLeft <= 2);
      next.classList.toggle('thered-arrow--disabled', scrollEl.scrollLeft >= max - 2);
    }
    scrollEl.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // give layout a tick to settle before first measure
    setTimeout(update, 50);
  }

  function init() {
    document.querySelectorAll('.collection-list.grid').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
